<div class="template-model">
  <app-top-header
    [parent]="parent"
    backRouterLink="/template-group"
    backRouterLinkLabel="TRANS__TEMPLATE_GROUP__TITLE"
    [queryParams]="{template_group_id: null}"
    queryParamsHandling="merge"
  ></app-top-header>

  <app-header-and-description
    heading="TRANS__TEMPLATE_MODEL__TITLE"
    description="TRANS__TEMPLATE_MODEL__INGRESS"
    headingName="{{templateGroupName}}"
  >
    <div class="template-model__content">
      <div class="template-button-container">
        <button
          mat-stroked-button
          color="primary"
          (click)="addTemplateModel()"
          class="template-model__button"
          [disabled]="createDisabled"
        >
          <mat-icon>
            edit
          </mat-icon>

          <span>
            {{ 'TRANS__TEMPLATE_GROUP__ADD_MODEL' | translate }}
          </span>
        </button>
      </div>

      @if (templateModels) {
        <ul class="template-list__content">
          @for (model of templateModels[AConst.FIELD_TEMPLATE_MODELS]; track $index) {
            <li class="template-list__item">
              <div class="template-list__object-overview">
                <h2>
                  <app-object-icon
                    class="template-model__object-overview-icon"
                    [object]="model.$$mockObject"
                  ></app-object-icon>

                  <app-object-name
                    [object]="model.$$mockObject"
                    class="bold"
                  ></app-object-name>
                </h2>

                @if (sectionsContainers[model.$$uuid]) {
                  <app-object-view-and-edit
                    [isEditing]="getModelIsEditing(model)"
                    [sectionsContainer]="sectionsContainers[model.$$uuid]"
                    [templateGroupId]="templateGroupId"
                  ></app-object-view-and-edit>
                }
              </div>
            </li>
          }
        </ul>
      }

      @if (debug && templateModels) {
        <div class="row">
          <pre>
            {{templateModels | json}}
          </pre>
        </div>
      }
    </div>

    @if (templateModel) {
      <div
        class="overlay template-model__overlay"
        (click)="disableTemplateModel()"
        (keydown)="null"
      ></div>

      <div class="side-selector template-model__edit">
        <h3>
          <span>
            {{templateGroupName}}:
          </span>

          <span>
            {{templateModel.artifact_name}}
          </span>
        </h3>

        @if (sectionsContainers[templateModel.$$uuid]) {
          <app-object-view-and-edit
            class="template-model__fields-container"
            [isEditing]="true"
            [sectionsContainer]="sectionsContainers[templateModel.$$uuid]"
            [templateGroupId]="templateGroupId"
          ></app-object-view-and-edit>
        }

        @if (debug) {
          <div class="row">
            <pre>
              {{templateModel | json}}
            </pre>
          </div>
        }

        <div class="template-model__action-toolbar">
          <div class="template-model__action-toolbar-container">
            <div class="template-model__action-buttons-container">
              @for (field of actionButtonFields; track $index) {
                <div class="template-model__action-buttons">
                  <app-field-action-button
                    [sectionsContainer]="sectionsContainers[templateModel.$$uuid]"
                    [field]="field"
                    (actionRun)="onActionRun(field)"
                  ></app-field-action-button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </app-header-and-description>
</div>

